<template>
  <div class="jobs-list" v-loading="loader">
    <div style="display: flex; flex-direction: column; margin-bottom: 12px; align-items: flex-start">
      <strong style="margin-bottom: 4px">Название плана</strong>
      <el-input v-model="plan_name" @change="save"/>
      <div style="margin-top: 12px">
        <el-checkbox @change="save" v-model="form.is_not_active">Не активен</el-checkbox>
      </div>
    </div>

    <div>
      <div class="jobs-ul">
        <router-link :to="`/dashboard/versions/users/${$route.params.id}`"
                     class="jobs-li"
        >
          <div class="name">
            <span style="margin-left: 10px">Компании</span>
          </div>
          <i class="fas fa-chevron-right"></i>
        </router-link>

        <router-link :to="`/dashboard/objects/?version=${$route.params.id}&name=${form.name}`"
                     class="jobs-li"
        >
          <div class="name">
            <span style="margin-left: 10px">Объекты</span>
          </div>
          <i class="fas fa-chevron-right"></i>
        </router-link>

        <router-link :to="`/dashboard/works/list?version=${$route.params.id}&name=${form.name}`"
                     class="jobs-li"
        >
          <div class="name">
            <span style="margin-left: 10px">Виды работ</span>
          </div>
          <i class="fas fa-chevron-right"></i>
        </router-link>

        <router-link :to="`/dashboard/dirs/?version=${$route.params.id}&name=${form.name}`"
                     class="jobs-li"
        >
          <div class="name">
            <span style="margin-left: 10px">Разделы работ</span>
          </div>
          <i class="fas fa-chevron-right"></i>
        </router-link>

        <div class="jobs-li mainPlan" @click="openPlanDialog = true">
          <div class="name">
            <span style="margin-left: 10px">Заполнить из основного плана</span>
          </div>
        </div>
      </div>
      <el-dialog
        title="Выбрать объекты и работы"
        append-to-body
        :visible.sync="openPlanDialog"
        custom-class="add-jobs-dialog"
      >
        <div v-loading="loading"
        >
          <el-form>
            <strong>Добавить план за указаный период:</strong>
            <div style="display: flex; align-items: center; margin-top: 4px">
              <date-picker
                style="margin-right: 10px"
                ref="datePicker"
                placeholder="Фильтр по дате"
                v-model="formDialog.datetimeRangeDownload"
                range
              ></date-picker>
              <el-checkbox v-model="formDialog.allPlan">Весь план</el-checkbox>
            </div>

            <div style="margin-top: 10px; margin-bottom: 10px">
              <filter-select multiple v-model="formDialog.companiesIds"
                             label="Выбрать планы только по указанным компаниям:" :options="usersOptions"/>

            </div>
            <el-button @click="openZoneDialog = true">Выбрать зоны работ</el-button>

            <div style="margin-top: 10px; margin-bottom: 10px">
              <filter-select multiple v-model="formDialog.executorsIds" label="Выбрать исполнителей работ"
                             :options="usersOptions"/>

            </div>
          </el-form>
          <PermissionObject @update="saveCopy" :versionId="$route.params.id"/>
          <el-dialog title="Выбрать зоны работ"
                     append-to-body
                     :visible.sync="openZoneDialog"
                     custom-class="add-jobs-dialog">

            <ZoneIndexVersion :zone-list="formDialog.zonesIds" @select="selectZone"/>
          </el-dialog>
        </div>
      </el-dialog>

      <div class="menu-settings">
        <strong>Общие настройки</strong>
        <div
          class="edit-li"
        >
          Учет сроков
          <el-checkbox @change="save" v-model="form.deadline_accounting"></el-checkbox>
        </div>
        <div
          class="edit-li"
        >
          Учет трудоемкости
          <el-checkbox @change="save" v-model="form.progress"></el-checkbox>
        </div>
        <div
          class="edit-li"
          style="flex-direction: column; height: auto; padding-top: 8px; padding-bottom: 8px; align-items: flex-start"
        >
          <div style="display: flex; justify-content: space-between; margin-bottom: 8px; width: 100%">
            Учет стоимости или второй ед. измерения
            <el-checkbox @change="save" v-model="form.price"></el-checkbox>
          </div>
          <el-input @change="save" :maxlength="9" style="max-width: 200px" v-model="form.unit_name" placeholder/>
        </div>
      </div>


      <el-form>
        <el-form-item label="Директивный срок начала проекта"
                      style="display: flex; flex-direction: column; align-items: flex-start">
          <div>
            <el-date-picker
              :editable="false"
              @input="changeDate"
              format="yyyy-MM-dd"
              v-model="form.start_date"
              type="date"
              placeholder="Укажите дату"
            >
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="Директивный срок окончания проекта"
                      style="display: flex; flex-direction: column; align-items: flex-start">
          <div>
            <el-date-picker
              @input="changeDate"
              :editable="false"
              format="yyyy-MM-dd"
              v-model="form.end_date"
              type="date"
              placeholder="Укажите дату"
            >
            </el-date-picker>
          </div>
        </el-form-item>
        <div class="menu-settings">
          <div class="edit-li">
            Факт по директивным срокам
            <el-checkbox @change="save" v-model="form.fact_by_date"></el-checkbox>
          </div>
        </div>
      </el-form>
    </div>
    <div class="remove-container" style="margin-top: 30px">
      <el-button style="width: 100%" type="danger" size="mini" @click="deleteObject" plain>Удалить</el-button>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase';
import _, {sample, uniq} from 'lodash';
import draggable from 'vuedraggable';
import work_units from '../../../data/work_units';
import {getUnits} from '../../../firestore/units';
import {getPlans} from "../../../firestore/plan";
import dayjs from "dayjs";
import PermissionObject from "./components/PermissionObject";
import DatePicker from "vue2-datepicker";
import {getUsersOptions} from "../../../firestore/users";
import FilterSelect from "../../../components/FilterSelect";
import ZoneIndexVersion from "./Zone";

export default {
  name: 'PlanIndex',
  components: {ZoneIndexVersion, FilterSelect, PermissionObject, draggable, DatePicker},

  data() {
    return {
      loader: false,
      loading: false,
      search: '',
      openPlanDialog: false,
      plans: [],
      openZoneDialog: false,
      usersOptions: [],
      plan_name: '',
      formDialog: {
        datetimeRangeDownload: [],
        companiesIds: [],
        executorsIds: [],
        allPlan: false,
        zonesIds: []
      },
      form: {
        start_date: null,
        end_date: null,
        is_not_active: false,
        deadline_accounting: false,
        fact_by_date: false,
        progress: false,
        price: false,
        unit_name: ''
      }
    };
  },

  async mounted() {
    if (this.$route.params.id) {
      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('versions')
        .doc(this.$route.params.id).get().then((response) => {
        const data = response.data();
        this.form = {
          ...this.form,
          ...data,
          start_date: dayjs(data.start_date).format('YYYY') === '1970' ? null : data.start_date,
          end_date: dayjs(data.end_date).format('YYYY') === '1970' ? null : data.end_date,
        };

        this.plan_name = this.form.name
      });

      const users = await getUsersOptions(this.$store.state.project.id, true)
      this.usersOptions = users.filter((u) => u._data.isCompany)
    }
  },
  methods: {
    saveCopy(d) {
      this.loading = true
      const objectsIds = d.availableObjects.map(({id}) => id)
      const jobsIds = []

      Object.values(d.availableJobs).forEach((d) => {
        d.forEach(({id}) => jobsIds.push(id))
      })

      const executorsIds = this.formDialog.executorsIds.map(({value}) => value)
      const companiesIds = this.formDialog.companiesIds.map(({value}) => value)
      const zonesIds = this.formDialog.zonesIds
      const planId = this.$route.params.id;
      const date = {}

      date.fromDate = dayjs(this.formDialog.datetimeRangeDownload[0]).format('YYYY-MM-DD')
      date.toDate = dayjs(this.formDialog.datetimeRangeDownload[1]).format('YYYY-MM-DD')


      const proxy = firebase.functions().httpsCallable('onParsePlanVersionByFilteredJobs');
      proxy(
        {
          executorsIds,
          companiesIds,
          zonesIds,
          planId,
          isAllPlan: this.formDialog.allPlan || false,
          objectsIds,
          jobsIds: uniq(jobsIds),
          ...date,
          projectId: this.$store.state.project.id
        },
      ).then((response) => {
        this.loading = false
        this.openPlanDialog = false
        this.$notify.success({
          offset: 60,
          title: 'Заполнено',
        });
      }).catch((e) => {
        this.loading = false
        this.$notify({
          offset: 60,
          title: 'Упс... ',
          message: 'Произошла ошибка повторите позже',
          type: 'error',
        });
      })
    },
    selectZone: _.debounce( function (e) {
      if (this.formDialog.zonesIds.includes(e)) {
        const index = this.formDialog.zonesIds.findIndex((id) => e === id)
        this.formDialog.zonesIds.splice(index, 1)
      } else {
        this.formDialog.zonesIds.push(e)
      }
      this.formDialog.zonesIds = [...this.formDialog.zonesIds]

      console.log(e)
    }, 50),
    changeDate() {
      if (this.form.start_date && this.form.end_date) {
        const s = '' + this.form.start_date;
        const e = '' + this.form.end_date;

        const start = dayjs(s).unix();
        const end = dayjs(e).unix();

        if (start && end && start > end) {
          this.form.start_date = null;
          this.$notify.error({title: 'Ошибка', message: 'Дата начала должна быть не позднее даты окончания'});
        } else {
          this.save()
        }
      }
    },
    save() {
      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('versions')
        .doc(this.$route.params.id)
        .update({
          ...this.form,
          start_date: this.form.start_date ? dayjs(this.form.start_date).format('YYYY-MM-DD') : null,
          end_date: this.form.end_date ? dayjs(this.form.end_date).format('YYYY-MM-DD') : null,
          name: this.plan_name
        }).then(() => {
        this.$notify({
          offset: 60,

          title: 'Успешно!',
          message: 'Сохранено',
          type: 'success',
        });

        if (this.$store.state.project.version && this.$store.state.project.version.id && this.$route.params.id === this.$store.state.project.version.id) {
          this.$store.dispatch('setProject', {
            ...this.$store.state.project,
            version: {...this.form, id: this.$route.params.id}
          });

          localStorage.setItem('version', JSON.stringify({...this.form, id: this.$route.params.id}))
        }
      }).catch((error) => console.error(error));
    },
    deleteObject(id) {
      this.$confirm('Вы действительно хотите удалить?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('versions')
          .doc(this.$route.params.id).delete()
          .then((data) => {
            this.$emit('update');
            this.fetchJobs();
            this.$notify({
              offset: 60,
              title: 'Успешно!',
              message: 'удалено',
              type: 'success',
            });
          });
      });
    },
  }
};
</script>

<style scoped lang="scss">
.jobs-list {
  max-width: 382px;
  width: calc(100% - 40px);
  margin: 22px auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: calc(100vh - 100px);
}


.input-search {
  margin-top: 12px;
}

.jobs-ul {
  display: flex;
  flex-direction: column;
  margin-top: 0px;

  .jobs-li {
    align-items: center;
    display: flex;
    justify-content: space-between;
    height: 48px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    cursor: pointer;
    padding: 0 12px;

    color: #000;
    text-decoration: none !important;

    &:hover {
      background: #f0f0f0;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}

.notify {
  background: #f0f0f0;
  color: #888;
  font-size: 13px;
  padding: 8px 4px;
  border-radius: 4px;
}

.add-job {
  > > > button {
    width: 100%;
    margin-top: 12px;
  }
}

.fa-chevron-right {
  color: #000;
}

.fa-trash {
  margin-right: 15px;
}

.name {
  display: flex;
  align-items: center;

  i {
    margin-right: 10px;
  }
}

.remove-container {
  display: flex;
}

.mainPlan {
  display: flex !important;
  justify-content: center !important;
}

.menu-settings {
  margin-top: 32px;

  .edit-li {
    display: flex;
    justify-content: space-between;
    height: 40px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    cursor: pointer;
    align-items: center;
    padding: 0 10px;
    text-decoration: none;
    color: #000;

    span:first-child {
      margin-right: 20px;
    }

    span {
      margin-right: 5px;
    }

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background: #f5f5f5;
    }
  }
}

strong {
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Versions/Edit.vue